// extracted by mini-css-extract-plugin
export default {"wrapper":"Theme_wrapper__ocxmP","theme":"Theme_theme__hHtv2"};